
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-inner">
        <h1 className="about-title">About TechTrove</h1>
        <p className="about-subtitle">Where Technology Meets Style</p>
        <p className="about-description">
          At <strong>TechTrove</strong>, we believe that gadgets aren't just tools—they're a way of life. 
          Founded with the mission to blend innovation and aesthetics, TechTrove brings you cutting-edge tech with a sleek touch.
        </p>
        <p className="about-description">
          Whether you're a gamer, creator, or just a curious tech lover, we’re here to offer handpicked products 
          that combine performance and personality.
        </p>
        <p className="about-footer">
          💡 Innovation. 🎨 Design. ❤️ Passion.
        </p>
      </div>
    </div>
  );
};

export default About;
